import { render } from "./MenuMinimized.vue?vue&type=template&id=a7675eec&scoped=true"
import script from "./MenuMinimized.vue?vue&type=script&lang=js"
export * from "./MenuMinimized.vue?vue&type=script&lang=js"

import "./MenuMinimized.vue?vue&type=style&index=0&id=a7675eec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7675eec"

export default script